import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MapComponent} from './map/map.component';
import {HttpClientModule} from '@angular/common/http';
import {ReportMalfunctionComponent} from './report-malfunction/report-malfunction.component';
import {FormsModule} from '@angular/forms';
import {ZoomWarningComponent} from './map/zoom-warning/zoom-warning.component';
import {PlaceSearchComponent} from './map/place-search/place-search.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {LoaderComponent} from './loader/loader.component';
import {HowItWorksComponent} from './how-it-works/how-it-works.component';
import {CookieService} from 'ngx-cookie-service';
import {PoweredByComponent} from './map/powered-by/powered-by.component';
import {MarkdownComponent} from './markdown/markdown.component';
import {NameFormatter} from './util/name-formatter';
import {BozNameFormatter} from './util/boz-name-formatter';
import {VzgNameFormatter} from './util/vzg-name-formatter';
import { LocationSearchComponent } from './map/location-search/location-search.component';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    ReportMalfunctionComponent,
    ZoomWarningComponent,
    PlaceSearchComponent,
    LoaderComponent,
    HowItWorksComponent,
    PoweredByComponent,
    MarkdownComponent,
    LocationSearchComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule
  ],
  providers: [
    CookieService,
    {
      provide: NameFormatter,
      useFactory: () => {
        const host = window.location.host.split('.')[0];
        switch (host) {
          case 'ovstoringbw':
          case 'ovloketsmallingerland':
            return new BozNameFormatter();
          default:
            return new VzgNameFormatter();
        }
      }
    }
  ],
  bootstrap: [AppComponent],
  exports: [MapComponent]
})
export class AppModule {
}
